/**
 * LGX-1098: "Add Charge" in Charge Details creates a row whose Charge field is still on the
 * "Select charge" placeholder. That row is not a charge — it must never reach the update
 * endpoint, or it gets persisted as an empty charge record.
 *
 * Shared by every path that submits Charge Details rows (the manual save and the automatic
 * rate refresh), since both build their payload from `shipmentDetails.charges` and so both
 * pick up an unsaved blank row.
 */

/** True when the user has not picked a charge type for this row yet. */
export const isUncodedCharge = (charge) =>
  !charge || typeof charge.code !== "string" || charge.code.trim() === "";

/** Payload-safe copy of `charges` with the unselected placeholder rows removed. */
export const withoutUncodedCharges = (charges = []) =>
  (charges || []).filter((charge) => !isUncodedCharge(charge));

/** Index of the first row still on "Select charge", or -1. Used to point the user at it. */
export const findUncodedChargeIndex = (charges = [], isSkipped = () => false) =>
  (charges || []).findIndex((charge, idx) => !isSkipped(idx) && isUncodedCharge(charge));
